import React from "react";
import { Link } from "react-router-dom";
import { useWorkspace } from "./useWorkspace";
import { GoalCard } from "./WorkspaceCards";
export default function GoalsPage() {
  const { data, isPending, error, refetch } = useWorkspace();
  return (
    <main className="unified-page">
      <header className="unified-page-header">
        <div>
          <p className="workspace-eyebrow">Goals</p>
          <h1>Keep the bigger picture.</h1>
          <p>Progress, next steps and check-ins across your work and life.</p>
        </div>
        <Link
          className="primary-button"
          to="/ai"
          state={{
            prompt:
              "Help me set up a new goal. Ask me what I want to achieve, what counts as progress, and when I want check-ins.",
          }}
        >
          Start a goal
        </Link>
      </header>
      {isPending ? (
        <p role="status">Loading your goals…</p>
      ) : error ? (
        <div role="alert">
          Your goals couldn’t load.
          <button onClick={() => refetch()}>Try again</button>
        </div>
      ) : (
        <>
          {["challenge", "routine", "plan"].map((kind) => {
            const rows = data.goals.filter((g) => g.kind === kind);
            return (
              rows.length > 0 && (
                <section className="library-group" key={kind}>
                  <h2>
                    {
                      {
                        challenge: "Challenges",
                        routine: "Routines",
                        plan: "Plans & projects",
                      }[kind]
                    }
                  </h2>
                  <div className="goal-grid">
                    {rows.map((goal) => (
                      <GoalCard
                        key={goal.id}
                        goal={goal}
                        timezone={data.timezone}
                      />
                    ))}
                  </div>
                </section>
              )
            );
          })}
          {!data.goals.length && (
            <div className="workspace-empty">
              <h2>Start with something that matters.</h2>
              <p>
                A training challenge, a learning plan, a trip or a work project.
              </p>
            </div>
          )}
          <section className="briefing-section">
            <h2>Learning roadmap</h2>
            {data.learning.up_next?.map((item) => (
              <Link className="schedule-row" key={item.id} to="/learning">
                <strong>{item.title}</strong>
                <span>
                  {item.status === "learning" ? "In progress" : "Up next"}
                </span>
              </Link>
            ))}
            <Link className="workspace-action" to="/learning">
              Open Learning
            </Link>
          </section>
        </>
      )}
    </main>
  );
}
